export default __webpack_public_path__ + "static/media/users.067bad91.svg";